function initializeViewer() {
  jQuery(".mad-slider__container--image,.mad-slider__container--image-row,.mad-slider__container--image2").each(function () {
      const container = jQuery(this);
      const htmlStructure = createHtmlStructure(container);

      // Disable the built-in nav buttons from the toolbar
      const viewer = new Viewer(htmlStructure, {
          toolbar: {
              zoomIn: true, // Enable zoom in
              zoomOut: true, // Enable zoom out
              prev: true, // Remove built-in previous button
              next: true, // Remove built-in next button
              play: false, // Disable play button
              rotateLeft: false, // Disable rotate left
              rotateRight: false, // Disable rotate right
              flipHorizontal: false, // Disable flip horizontal
              flipVertical: false // Disable flip vertical
          },
          title: false, // Remove image name
          navbar: true, // Enable the navbar
          zoomRatio: 0.3, // Increase zoom speed (default is 0.1)
          viewed: function () {
            const canvas = this.viewer.canvas;
            if (canvas) {
                const viewerContainer = canvas.closest('.viewer-container');
        
                // Create navigation overlay if it doesn't exist
                if (viewerContainer && !viewerContainer.querySelector('.mad-image-viewer__overlay')) {
                    const overlay = document.createElement('div');
                    overlay.className = 'mad-image-viewer__overlay';
        
                    const prevBtn = document.createElement('button');
                    prevBtn.className = 'mad-image-viewer__overlay__button--prev dashicons dashicons-arrow-left-alt2';
                    prevBtn.addEventListener('click', () => {
                        if (this.viewer.index === 0) {
                          this.viewer.view(this.viewer.images.length - 1);
                        } else {
                          this.viewer.prev();
                        }
                    });
                    overlay.appendChild(prevBtn);
        
                    const nextBtn = document.createElement('button');
                    nextBtn.className = 'mad-image-viewer__overlay__button--next dashicons dashicons-arrow-right-alt2';
                    nextBtn.addEventListener('click', () => {
                      // If at the last image, loop to the first
                      if (this.viewer.index === this.viewer.images.length - 1) {
                        this.viewer.view(0);
                      } else {
                        this.viewer.next();
                      }
                    });
                    overlay.appendChild(nextBtn);
        
                    viewerContainer.appendChild(overlay);
                }
        
                // Update the title card using a crossfade effect if Title and Subtitle exist
                const currentImage = this.viewer.image;
                if (currentImage && (currentImage.alt !== 'Slider Image')) {
                    const altText = currentImage.alt || "";
                    const parts = altText.split("#");
                    const titleText = parts[0] ? parts[0].trim() : "";
                    const subtitleText = parts[1] ? parts[1].trim() : "";
                    const newContent = `<div class="mad-image-viewer__title">${titleText}</div><div class="mad-image-viewer__subtitle">${subtitleText}</div>`;
        
                    const oldCard = viewerContainer.querySelector('.mad-image-viewer__title-card');
        
                    const newCard = document.createElement('div');
                    newCard.className = 'mad-image-viewer__title-card';
                    newCard.innerHTML = newContent;
                    newCard.style.opacity = 0;
                    viewerContainer.appendChild(newCard);
        
                    // Animate the new title card fade in concurrently with fading out the old card.
                    jQuery(newCard).animate({ opacity: 1 }, 100);
                    if (oldCard) {
                        jQuery(oldCard).animate({ opacity: 0 }, 100, function() {
                            oldCard.remove();
                          });
                      }
                  }
              }
          },
          hidden: function() {
            // When the viewer is closed, fade out any custom title cards
            const canvas = this.viewer.canvas;
            if (canvas) {
                const viewerContainer = canvas.closest('.viewer-container');
                jQuery(viewerContainer)
                    .find('.mad-image-viewer__title-card')
                    .fadeOut(200, function() {
                        jQuery(this).remove();
                    });
            }
        }
      });

      container.find(".mad-slider__body").each(function (index) {
          addClickCallback(jQuery(this), viewer, index);
      });
  });
}

function createHtmlStructure(container) {
    const htmlStructure = document.createElement("div");
    const imageDetails = []; // store title/subtitle data per image

    container.find(".mad-slider__body").each(function () {
        const backgroundImage = jQuery(this).css("background-image");
        const dataImageUrl = jQuery(this).attr("data-bgimage");
        const urlMatch = backgroundImage.match(/url\("?(.*?)"?\)/);
        const img = document.createElement("img");

        // Set the image source
        if (dataImageUrl) {
          img.src = dataImageUrl;
        } else if (urlMatch && urlMatch[1]) {
          img.src = urlMatch[1];
        }

        if (img.src) {
          // Get title and subtitle from the parent slide element
          const slide = jQuery(this).closest('.mad-slider__slide');
          const title = slide.data('title') || '';
          const subtitle = slide.data('subtitle') || '';

          if (title === '' && subtitle === '') {
            img.alt = "Slider Image";
          } else {
            imageDetails.push({ title, subtitle });
            img.alt = `${title}#${subtitle}`;
          }
          htmlStructure.appendChild(img);
        }
    });

    // Attach our custom detail mapping to be used later in the viewer
    htmlStructure.imageDetails = imageDetails;
    return htmlStructure;
}

function addClickCallback(sliderBody, viewer, index) {
  sliderBody.on("click", () => {
      viewer.view(index);
  });
}

function adjustViewerContainerMargin() {
  const adminBar = jQuery("#wpadminbar");
  const viewerContainer = jQuery(".viewer-container");

  if (adminBar.length && viewerContainer.length) {
      const adminBarHeight = adminBar.outerHeight();
      addMarginTopStyle(adminBarHeight);
  }
}

// Main callback
$dependencyManager.addDependencyCallback('viewerjs', () => {
  initializeViewer();
});
